export const filterEnabledCols = [
  "branch_name",
  "first_name",
  "last_name",
  "email_id",
  "employee_id",
  "department_names",
  "account_disabled",
  "belongsto_group_names",
  "default_myview_name",
  "default_category",
  "pinned_views_for_myview",
  "task_location_names",
  "title_or_level_names",
  "primary_role_name",
  "industry_names",
  "expertise_names",
  "secondary_role_name",
  "niche_or_group_names"
];
